module.exports = __webpack_public_path__ + "img/meeting-room.e0c0ef2c.svg";